export const lastReported = {
  1: {
    start: "2020-01-01",
    end: "2020-12-01",
  },
  2: {
    start: "2021-01-01",
    end: "2021-12-01",
  },
  3: {
    start: "2022-01-01",
    end: "2022-12-01",
  },
  4: {
    start: "2023-01-01",
    end: "2023-12-01",
  },
  5: {
    start: "2024-01-01",
    end: "2024-12-01",
  },
  6: {
    start: "2025-01-01",
    end: "2025-12-01",
  },
  7: {
    start: "2025-12-01",
    end: "2025-12-31",
  },
};
